import Vue from 'vue'
import Antd from 'ant-design-vue';
import JsonExcel from "vue-json-excel";

Vue.config.productionTip = false
Vue.component("downloadExcel", JsonExcel);
Vue.use(Antd);
